import { ModalHandler } from '@app-velocity/ui';

import { NoMoreCreditsLeftModalContent } from './components/NoMoreCreditsLeftModalContent';

export const NoMoreCreditsLeftModal = () => {
  return (
    <ModalHandler channel="users" id="no-more-credits">
      <NoMoreCreditsLeftModalContent />
    </ModalHandler>
  );
};
